module.exports = __webpack_public_path__ + "img/sdgs_benefits.0cb932bb.jpeg";